import { validator } from "@/utils/validator";

export const createOrganizationSchema = validator.object().shape({
  name: validator.string().emptyToNull().max(200).label("組織名").required(),
  type: validator.string().isSelection().emptyToNull().label("機関種別").required(),
  province: validator.string().emptyToNull().label("都道府県").nullable().notRequired(),
  municipality: validator.string().emptyToNull().label("市区町村").nullable().notRequired(),
  crmLink: validator.string().emptyToNull().customURL().max(500).label("CRMリンク").nullable().notRequired(),
  adminInfo: validator.string().emptyToNull().max(1000).label("顧客情報").nullable().notRequired(),
  adminNotes: validator.string().emptyToNull().max(1000).label("内部メモ").nullable().notRequired(),
});
